import { Fancybox } from '@fancyapps/ui';

/**
 * Binds every `[data-fancybox]` anchor, including ones teleported or rendered by Livewire later.
 *
 * `Hash` is disabled because Fancybox would otherwise append `#gallery` to the URL, which
 * Livewire's history listener treats as a navigation and refreshes the page.
 */
export function setupFancybox() {
    Fancybox.bind('[data-fancybox]', { on: document, Hash: false });
}

/**
 * Opens the lightbox for a `data-fancybox` group, starting at the given image.
 *
 * @param {string} group
 * @param {number} startIndex
 */
export function openGallery(group, startIndex = 0) {
    const items = Array.from(document.querySelectorAll(`[data-fancybox="${group}"]`)).map((element) => ({
        src: element.href,
        type: 'image',
    }));

    Fancybox.show(items, {
        startIndex,
        Toolbar: { display: { left: [], middle: [], right: ['close'] } },
        Images: { zoom: false },
        animated: true,
        Hash: false,
    });
}
